import {Modal,Icon,} from "semantic-ui-react";

const ModalDocument =({handleCloseModal,handleOpenModal,openModal, documento}:any)=> {


    
    return (

        <Modal
            size="small"
            onClose={handleCloseModal}
            onOpen={handleOpenModal}
            open={openModal}
            centered={false}
            closeIcon={
            <Icon
                name="x"
                style={{
                    color: "#9F0505",
                    position: "absolute",
                    right: 20,
                    top: 25,
                    cursor: "pointer",
                }}
            />
        }
            >
                <iframe  style={{width:'100%', height:'700px'}} title='documento' src={documento}>

                </iframe>
        </Modal>

    )
}

export default ModalDocument

